import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-link',
  templateUrl: './form-link.component.html',
  styleUrls: ['./form-link.component.scss']
})
export class FormLinkComponent implements OnInit {
  ngOnInit(): void {
  }
  
}
